import { formatDealsEditionBadge, formatDealsEditionDate } from '../dealsEditionDate';

const EDITION_INFO =
  'Featured selection rotates daily on this page. Retailers set their own prices and they can change anytime.';

/**
 * @param {{
 *   validFor: string,
 *   categoryCount: number,
 * }} props
 */
export function DealsDailyEdition({ validFor, categoryCount }) {
  const editionBadge = formatDealsEditionBadge(validFor);
  const editionDate = formatDealsEditionDate(validFor);
  const categoryLabel = categoryCount === 1 ? 'category' : 'categories';

  return (
    <aside
      className="deals-page__edition"
      aria-label={`${editionBadge}, today's hand-picked deals`}
    >
      <div className="deals-page__edition-top">
        <p className="deals-page__edition-badge">{editionBadge}</p>
        <button
          type="button"
          className="deals-page__edition-info"
          aria-label={EDITION_INFO}
          title={EDITION_INFO}
        >
          i
        </button>
      </div>
      <p className="deals-page__edition-headline">
        <span className="deals-page__edition-count">
          Today&apos;s hand-picked deals
        </span>
        <span className="deals-page__edition-sep" aria-hidden="true">
          {' '}
          ·{' '}
        </span>
        <span className="deals-page__edition-date">{editionDate}</span>
      </p>
      <p className="deals-page__edition-return">
        New featured shortlist tomorrow morning
        {categoryCount > 0 && (
          <span className="deals-page__edition-return-detail">
            {' '}
            across {categoryCount} {categoryLabel}
          </span>
        )}
      </p>
    </aside>
  );
}
